const HtmlElements = {
	b: 'b',
	p: 'p',
	i: 'i',
	strong: 'strong',
	del: 'del',
	s: 's',
	u: 'u',
	em: 'em',
	h1: 'h1',
	h2: 'h2',
	h3: 'h3',
	br: 'br',
	li: 'li',
	ul: 'ul',
	ol: 'ol',
	a: 'a',
	span: 'span',
} as const;

export default HtmlElements;
